import { useFlags } from '@mint-lib/admin-routing-context';
import { useTranslation } from '@mint-lib/i18n';
import type { IconsList } from '@mint-lib/icons/allIcons';
import { type ToOptions } from '@mint/admin-routing';

type Item = {
  id: string;
  title: string;
  icon?: IconsList;
  expandable?: boolean;
  selected?: boolean;
  path?: ToOptions['to'];
  subItems?: Item[];
  hidden?: boolean;
};

export const useSideBarItems = (): Item[] => {
  const { t } = useTranslation('@mint-admin/secured-layout');
  const ff = useFlags('@mint/arm', ['metricsManagerSideBar']);

  return [
    {
      id: 'taxonomy',
      title: t('Taxonomy'),
      icon: 'Table',
      expandable: true,
      subItems: [
        {
          id: 'metadata',
          path: '/taxonomy/metadata' as ToOptions['to'],
          title: t('Fields Manager'),
        },
        {
          id: 'metrics-manager',
          path: '/taxonomy/metrics-manager' as ToOptions['to'],
          title: t('Metrics Manager'),
          hidden: !ff.metricsManagerSideBar.enabled,
        },
      ],
    },
    {
      id: 'margins',
      title: t('Margins'),
      path: '/margins' as ToOptions['to'],
      icon: 'Numbers',
    },
  ];
};
